import HeaderYokai from './HeaderYokai'
import YokaiAbout from './YokaiAbout'
import Footer from './Footer'

import './Kotyatki.css'

function Yokai() {
  return (
    <>
      <HeaderYokai/>
      <YokaiAbout/>
      <Footer/>
    </>
  )
}

export default Yokai
